/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CompanyCustomizationsResponse,
  DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileIdParams,
  DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserParams,
  ErrorResponse,
  GetApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdParams,
  GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrentParams,
  GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams,
  GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaIdParams,
  GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsParams,
  GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActiveParams,
  GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalanceParams,
  GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrentParams,
  GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaParams,
  GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaIdParams,
  GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframeParams,
  GetApiPermissionsDefinitionsParams,
  GetApiUsersCurrentCustomizationsParams,
  GetApiUsersCurrentLocalizationLanguageParams,
  PatchApiUsersCurrentLocalizationLanguageParams,
  PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileBody,
  PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileParams,
  PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserParams,
  PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublishParams,
  PostApiCompaniesCurrentFileexchangeDraftParams,
  ProjectModel,
  TimeQuotaBalanceModel,
  TimeQuotaModel,
  TimeQuotaRevisionModel,
  UpdateDocumentExchangeWalletResponse,
  VacationQuotaModel,
  VacationQuotaRevisionModel
} from '../../model';

import { axiosInstance } from '../../axios-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota = (
    serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaParams,
 signal?: AbortSignal
) => {


      return axiosInstance<TimeQuotaModel[]>(
      {url: `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timequota`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaQueryKey = (serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaParams,) => {
    return [
    `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timequota`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, TError = ErrorResponse>(serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaQueryKey(serviceModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota(serviceModuleId,params, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>>
export type GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: undefined |  GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaQueryOptions(serviceModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects = (
    serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<ProjectModel[]>(
      {url: `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/projects`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsQueryKey = (serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsParams,) => {
    return [
    `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/projects`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>, TError = ErrorResponse>(serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsQueryKey(serviceModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects(serviceModuleId,params, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>>
export type GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: undefined |  GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsQueryOptions(serviceModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota = (
    serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams,
 signal?: AbortSignal
) => {


      return axiosInstance<VacationQuotaModel[] | void>(
      {url: `/api/companies/current/servicemodules/absence/${serviceModuleId}/vacationquota`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaQueryKey = (serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams,) => {
    return [
    `/api/companies/current/servicemodules/absence/${serviceModuleId}/vacationquota`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, TError = ErrorResponse>(serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaQueryKey(serviceModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota(serviceModuleId,params, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>>
export type GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: undefined |  GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaQueryOptions(serviceModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiUsersCurrentLocalizationLanguage = (
    params?: GetApiUsersCurrentLocalizationLanguageParams,
 signal?: AbortSignal
) => {


      return axiosInstance<string>(
      {url: `/api/users/current/localization/language`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiUsersCurrentLocalizationLanguageQueryKey = (params?: GetApiUsersCurrentLocalizationLanguageParams,) => {
    return [
    `/api/users/current/localization/language`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiUsersCurrentLocalizationLanguageQueryOptions = <TData = Awaited<ReturnType<typeof getApiUsersCurrentLocalizationLanguage>>, TError = ErrorResponse>(params?: GetApiUsersCurrentLocalizationLanguageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentLocalizationLanguage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUsersCurrentLocalizationLanguageQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersCurrentLocalizationLanguage>>> = ({ signal }) => getApiUsersCurrentLocalizationLanguage(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentLocalizationLanguage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiUsersCurrentLocalizationLanguageQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersCurrentLocalizationLanguage>>>
export type GetApiUsersCurrentLocalizationLanguageQueryError = ErrorResponse


export function useGetApiUsersCurrentLocalizationLanguage<TData = Awaited<ReturnType<typeof getApiUsersCurrentLocalizationLanguage>>, TError = ErrorResponse>(
 params: undefined |  GetApiUsersCurrentLocalizationLanguageParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentLocalizationLanguage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersCurrentLocalizationLanguage>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersCurrentLocalizationLanguage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUsersCurrentLocalizationLanguage<TData = Awaited<ReturnType<typeof getApiUsersCurrentLocalizationLanguage>>, TError = ErrorResponse>(
 params?: GetApiUsersCurrentLocalizationLanguageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentLocalizationLanguage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersCurrentLocalizationLanguage>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersCurrentLocalizationLanguage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUsersCurrentLocalizationLanguage<TData = Awaited<ReturnType<typeof getApiUsersCurrentLocalizationLanguage>>, TError = ErrorResponse>(
 params?: GetApiUsersCurrentLocalizationLanguageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentLocalizationLanguage>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiUsersCurrentLocalizationLanguage<TData = Awaited<ReturnType<typeof getApiUsersCurrentLocalizationLanguage>>, TError = ErrorResponse>(
 params?: GetApiUsersCurrentLocalizationLanguageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentLocalizationLanguage>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiUsersCurrentLocalizationLanguageQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiUsersCurrentLocalizationLanguage = (
    params?: PatchApiUsersCurrentLocalizationLanguageParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/users/current/localization/language`, method: 'PATCH',
        params, signal
    },
      );
    }




export const getPatchApiUsersCurrentLocalizationLanguageMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiUsersCurrentLocalizationLanguage>>, TError,{params?: PatchApiUsersCurrentLocalizationLanguageParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiUsersCurrentLocalizationLanguage>>, TError,{params?: PatchApiUsersCurrentLocalizationLanguageParams}, TContext> => {

const mutationKey = ['patchApiUsersCurrentLocalizationLanguage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiUsersCurrentLocalizationLanguage>>, {params?: PatchApiUsersCurrentLocalizationLanguageParams}> = (props) => {
          const {params} = props ?? {};

          return  patchApiUsersCurrentLocalizationLanguage(params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiUsersCurrentLocalizationLanguageMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiUsersCurrentLocalizationLanguage>>>

    export type PatchApiUsersCurrentLocalizationLanguageMutationError = ErrorResponse

    export const usePatchApiUsersCurrentLocalizationLanguage = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiUsersCurrentLocalizationLanguage>>, TError,{params?: PatchApiUsersCurrentLocalizationLanguageParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiUsersCurrentLocalizationLanguage>>,
        TError,
        {params?: PatchApiUsersCurrentLocalizationLanguageParams},
        TContext
      > => {
      return useMutation(getPatchApiUsersCurrentLocalizationLanguageMutationOptions(options), queryClient);
    }
    export const getApiPermissionsDefinitions = (
    params?: GetApiPermissionsDefinitionsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/permissions/definitions`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiPermissionsDefinitionsQueryKey = (params?: GetApiPermissionsDefinitionsParams,) => {
    return [
    `/api/permissions/definitions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiPermissionsDefinitionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiPermissionsDefinitions>>, TError = ErrorResponse>(params?: GetApiPermissionsDefinitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPermissionsDefinitions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPermissionsDefinitionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPermissionsDefinitions>>> = ({ signal }) => getApiPermissionsDefinitions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPermissionsDefinitions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPermissionsDefinitionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPermissionsDefinitions>>>
export type GetApiPermissionsDefinitionsQueryError = ErrorResponse


export function useGetApiPermissionsDefinitions<TData = Awaited<ReturnType<typeof getApiPermissionsDefinitions>>, TError = ErrorResponse>(
 params: undefined |  GetApiPermissionsDefinitionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPermissionsDefinitions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPermissionsDefinitions>>,
          TError,
          Awaited<ReturnType<typeof getApiPermissionsDefinitions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPermissionsDefinitions<TData = Awaited<ReturnType<typeof getApiPermissionsDefinitions>>, TError = ErrorResponse>(
 params?: GetApiPermissionsDefinitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPermissionsDefinitions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPermissionsDefinitions>>,
          TError,
          Awaited<ReturnType<typeof getApiPermissionsDefinitions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPermissionsDefinitions<TData = Awaited<ReturnType<typeof getApiPermissionsDefinitions>>, TError = ErrorResponse>(
 params?: GetApiPermissionsDefinitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPermissionsDefinitions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPermissionsDefinitions<TData = Awaited<ReturnType<typeof getApiPermissionsDefinitions>>, TError = ErrorResponse>(
 params?: GetApiPermissionsDefinitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPermissionsDefinitions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPermissionsDefinitionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiUsersCurrentCustomizations = (
    params?: GetApiUsersCurrentCustomizationsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<CompanyCustomizationsResponse>(
      {url: `/api/users/current/customizations`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiUsersCurrentCustomizationsQueryKey = (params?: GetApiUsersCurrentCustomizationsParams,) => {
    return [
    `/api/users/current/customizations`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiUsersCurrentCustomizationsQueryOptions = <TData = Awaited<ReturnType<typeof getApiUsersCurrentCustomizations>>, TError = ErrorResponse>(params?: GetApiUsersCurrentCustomizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentCustomizations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUsersCurrentCustomizationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersCurrentCustomizations>>> = ({ signal }) => getApiUsersCurrentCustomizations(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentCustomizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiUsersCurrentCustomizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersCurrentCustomizations>>>
export type GetApiUsersCurrentCustomizationsQueryError = ErrorResponse


export function useGetApiUsersCurrentCustomizations<TData = Awaited<ReturnType<typeof getApiUsersCurrentCustomizations>>, TError = ErrorResponse>(
 params: undefined |  GetApiUsersCurrentCustomizationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentCustomizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersCurrentCustomizations>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersCurrentCustomizations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUsersCurrentCustomizations<TData = Awaited<ReturnType<typeof getApiUsersCurrentCustomizations>>, TError = ErrorResponse>(
 params?: GetApiUsersCurrentCustomizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentCustomizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersCurrentCustomizations>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersCurrentCustomizations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUsersCurrentCustomizations<TData = Awaited<ReturnType<typeof getApiUsersCurrentCustomizations>>, TError = ErrorResponse>(
 params?: GetApiUsersCurrentCustomizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentCustomizations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiUsersCurrentCustomizations<TData = Awaited<ReturnType<typeof getApiUsersCurrentCustomizations>>, TError = ErrorResponse>(
 params?: GetApiUsersCurrentCustomizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentCustomizations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiUsersCurrentCustomizationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesCurrentFileexchangeDraft = (
    params?: PostApiCompaniesCurrentFileexchangeDraftParams,
 signal?: AbortSignal
) => {


      return axiosInstance<number>(
      {url: `/api/companies/current/fileexchange/draft`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiCompaniesCurrentFileexchangeDraftMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDraft>>, TError,{params?: PostApiCompaniesCurrentFileexchangeDraftParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDraft>>, TError,{params?: PostApiCompaniesCurrentFileexchangeDraftParams}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentFileexchangeDraft'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDraft>>, {params?: PostApiCompaniesCurrentFileexchangeDraftParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCompaniesCurrentFileexchangeDraft(params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentFileexchangeDraftMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDraft>>>

    export type PostApiCompaniesCurrentFileexchangeDraftMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentFileexchangeDraft = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDraft>>, TError,{params?: PostApiCompaniesCurrentFileexchangeDraftParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDraft>>,
        TError,
        {params?: PostApiCompaniesCurrentFileexchangeDraftParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentFileexchangeDraftMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId = (
    documentExchangeWalletId: number,
    params?: GetApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<UpdateDocumentExchangeWalletResponse>(
      {url: `/api/companies/current/fileexchange/${documentExchangeWalletId}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdQueryKey = (documentExchangeWalletId: number,
    params?: GetApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdParams,) => {
    return [
    `/api/companies/current/fileexchange/${documentExchangeWalletId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId>>, TError = ErrorResponse>(documentExchangeWalletId: number,
    params?: GetApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdQueryKey(documentExchangeWalletId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId>>> = ({ signal }) => getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId(documentExchangeWalletId,params, signal);





   return  { queryKey, queryFn, enabled: documentExchangeWalletId !== null && documentExchangeWalletId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId>>>
export type GetApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdQueryError = ErrorResponse


export function useGetApiCompaniesCurrentFileexchangeDocumentExchangeWalletId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId>>, TError = ErrorResponse>(
 documentExchangeWalletId: number,
    params: undefined |  GetApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentFileexchangeDocumentExchangeWalletId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId>>, TError = ErrorResponse>(
 documentExchangeWalletId: number,
    params?: GetApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentFileexchangeDocumentExchangeWalletId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId>>, TError = ErrorResponse>(
 documentExchangeWalletId: number,
    params?: GetApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentFileexchangeDocumentExchangeWalletId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId>>, TError = ErrorResponse>(
 documentExchangeWalletId: number,
    params?: GetApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentFileexchangeDocumentExchangeWalletId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdQueryOptions(documentExchangeWalletId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublish = (
    documentExchangeWalletId: number,
    params?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublishParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/fileexchange/${documentExchangeWalletId}/publish`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublishMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublish>>, TError,{documentExchangeWalletId: number;params?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublishParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublish>>, TError,{documentExchangeWalletId: number;params?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublishParams}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublish'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublish>>, {documentExchangeWalletId: number;params?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublishParams}> = (props) => {
          const {documentExchangeWalletId,params} = props ?? {};

          return  postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublish(documentExchangeWalletId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublishMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublish>>>

    export type PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublishMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublish = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublish>>, TError,{documentExchangeWalletId: number;params?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublishParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublish>>,
        TError,
        {documentExchangeWalletId: number;params?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublishParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdPublishMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFile = (
    documentExchangeWalletId: number,
    postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileBody?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileBody,
    params?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileParams,
 signal?: AbortSignal
) => {

      const formData = new FormData();
if(postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileBody?.File !== undefined) {
 formData.append(`File`, postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileBody.File);
 }

      return axiosInstance<UpdateDocumentExchangeWalletResponse>(
      {url: `/api/companies/current/fileexchange/${documentExchangeWalletId}/file`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData,
        params, signal
    },
      );
    }




export const getPostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFile>>, TError,{documentExchangeWalletId: number;data?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileBody;params?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFile>>, TError,{documentExchangeWalletId: number;data?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileBody;params?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileParams}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFile>>, {documentExchangeWalletId: number;data?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileBody;params?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileParams}> = (props) => {
          const {documentExchangeWalletId,data,params} = props ?? {};

          return  postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFile(documentExchangeWalletId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFile>>>
    export type PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileMutationBody = PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileBody | undefined
    export type PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFile = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFile>>, TError,{documentExchangeWalletId: number;data?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileBody;params?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFile>>,
        TError,
        {documentExchangeWalletId: number;data?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileBody;params?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileId = (
    documentExchangeWalletId: number,
    fileId: number,
    params?: DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<number>(
      {url: `/api/companies/current/fileexchange/${documentExchangeWalletId}/file/${fileId}`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileId>>, TError,{documentExchangeWalletId: number;fileId: number;params?: DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileId>>, TError,{documentExchangeWalletId: number;fileId: number;params?: DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileIdParams}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileId>>, {documentExchangeWalletId: number;fileId: number;params?: DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileIdParams}> = (props) => {
          const {documentExchangeWalletId,fileId,params} = props ?? {};

          return  deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileId(documentExchangeWalletId,fileId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileId>>>

    export type DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileId>>, TError,{documentExchangeWalletId: number;fileId: number;params?: DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileId>>,
        TError,
        {documentExchangeWalletId: number;fileId: number;params?: DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileIdParams},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdFileFileIdMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser = (
    documentExchangeWalletId: number,
    params?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserParams,
 signal?: AbortSignal
) => {


      return axiosInstance<UpdateDocumentExchangeWalletResponse>(
      {url: `/api/companies/current/fileexchange/${documentExchangeWalletId}/managementuser`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser>>, TError,{documentExchangeWalletId: number;params?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser>>, TError,{documentExchangeWalletId: number;params?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserParams}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser>>, {documentExchangeWalletId: number;params?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserParams}> = (props) => {
          const {documentExchangeWalletId,params} = props ?? {};

          return  postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser(documentExchangeWalletId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser>>>

    export type PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser>>, TError,{documentExchangeWalletId: number;params?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser>>,
        TError,
        {documentExchangeWalletId: number;params?: PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser = (
    documentExchangeWalletId: number,
    params?: DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserParams,
 signal?: AbortSignal
) => {


      return axiosInstance<UpdateDocumentExchangeWalletResponse>(
      {url: `/api/companies/current/fileexchange/${documentExchangeWalletId}/managementuser`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser>>, TError,{documentExchangeWalletId: number;params?: DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser>>, TError,{documentExchangeWalletId: number;params?: DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserParams}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser>>, {documentExchangeWalletId: number;params?: DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserParams}> = (props) => {
          const {documentExchangeWalletId,params} = props ?? {};

          return  deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser(documentExchangeWalletId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser>>>

    export type DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser>>, TError,{documentExchangeWalletId: number;params?: DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuser>>,
        TError,
        {documentExchangeWalletId: number;params?: DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserParams},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdManagementuserMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId = (
    serviceModuleId: number,
    timeQuotaId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<TimeQuotaRevisionModel[]>(
      {url: `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timequota/revisions/${timeQuotaId}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaIdQueryKey = (serviceModuleId: number,
    timeQuotaId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaIdParams,) => {
    return [
    `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timequota/revisions/${timeQuotaId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId>>, TError = ErrorResponse>(serviceModuleId: number,
    timeQuotaId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaIdQueryKey(serviceModuleId,timeQuotaId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId(serviceModuleId,timeQuotaId,params, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined && timeQuotaId !== null && timeQuotaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId>>>
export type GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaIdQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId>>, TError = ErrorResponse>(
 serviceModuleId: number,
    timeQuotaId: number,
    params: undefined |  GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId>>, TError = ErrorResponse>(
 serviceModuleId: number,
    timeQuotaId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId>>, TError = ErrorResponse>(
 serviceModuleId: number,
    timeQuotaId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId>>, TError = ErrorResponse>(
 serviceModuleId: number,
    timeQuotaId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaRevisionsTimeQuotaIdQueryOptions(serviceModuleId,timeQuotaId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent = (
    serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrentParams,
 signal?: AbortSignal
) => {


      return axiosInstance<TimeQuotaModel>(
      {url: `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timequota/current`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrentQueryKey = (serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrentParams,) => {
    return [
    `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timequota/current`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrentQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent>>, TError = ErrorResponse>(serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrentQueryKey(serviceModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent(serviceModuleId,params, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrentQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent>>>
export type GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrentQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: undefined |  GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrent>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaCurrentQueryOptions(serviceModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance = (
    serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalanceParams,
 signal?: AbortSignal
) => {


      return axiosInstance<TimeQuotaBalanceModel | void>(
      {url: `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timequota/balance`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalanceQueryKey = (serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalanceParams,) => {
    return [
    `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timequota/balance`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalanceQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance>>, TError = ErrorResponse>(serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalanceQueryKey(serviceModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance(serviceModuleId,params, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance>>>
export type GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalanceQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: undefined |  GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalanceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalance>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaBalanceQueryOptions(serviceModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive = (
    serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActiveParams,
 signal?: AbortSignal
) => {


      return axiosInstance<TimeQuotaModel>(
      {url: `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timequota/active`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActiveQueryKey = (serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActiveParams,) => {
    return [
    `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timequota/active`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActiveQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive>>, TError = ErrorResponse>(serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActiveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActiveQueryKey(serviceModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive(serviceModuleId,params, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActiveQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive>>>
export type GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActiveQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: undefined |  GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActiveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActiveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActiveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActiveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActive>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaActiveQueryOptions(serviceModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Return a list of all time quotas during the given time frame, defined by fromDate and toDate.Gives all data of every day during that time frame (the whole weeks of that time frame), so that the backend can display each day's worked minutes. It is recommended to call this in tandem with the balance endpoint for the given toDate to get a final balance.
 */
export const getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe = (
    serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframeParams,
 signal?: AbortSignal
) => {


      return axiosInstance<TimeQuotaModel[] | ErrorResponse>(
      {url: `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timequota/timeframe`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframeQueryKey = (serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframeParams,) => {
    return [
    `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timequota/timeframe`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframeQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe>>, TError = ErrorResponse>(serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframeQueryKey(serviceModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe(serviceModuleId,params, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe>>>
export type GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframeQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: undefined |  GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframe>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaTimeframeQueryOptions(serviceModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent = (
    serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrentParams,
 signal?: AbortSignal
) => {


      return axiosInstance<VacationQuotaModel | void>(
      {url: `/api/companies/current/servicemodules/absence/${serviceModuleId}/vacationquota/current`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrentQueryKey = (serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrentParams,) => {
    return [
    `/api/companies/current/servicemodules/absence/${serviceModuleId}/vacationquota/current`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrentQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent>>, TError = ErrorResponse>(serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrentQueryKey(serviceModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent(serviceModuleId,params, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrentQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent>>>
export type GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrentQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: undefined |  GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrent>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaCurrentQueryOptions(serviceModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId = (
    serviceModuleId: number,
    vacationQuotaId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<VacationQuotaRevisionModel[]>(
      {url: `/api/companies/current/servicemodules/absence/${serviceModuleId}/vacationquota/revisions/${vacationQuotaId}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaIdQueryKey = (serviceModuleId: number,
    vacationQuotaId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaIdParams,) => {
    return [
    `/api/companies/current/servicemodules/absence/${serviceModuleId}/vacationquota/revisions/${vacationQuotaId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId>>, TError = ErrorResponse>(serviceModuleId: number,
    vacationQuotaId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaIdQueryKey(serviceModuleId,vacationQuotaId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId(serviceModuleId,vacationQuotaId,params, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined && vacationQuotaId !== null && vacationQuotaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId>>>
export type GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaIdQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId>>, TError = ErrorResponse>(
 serviceModuleId: number,
    vacationQuotaId: number,
    params: undefined |  GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId>>, TError = ErrorResponse>(
 serviceModuleId: number,
    vacationQuotaId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId>>, TError = ErrorResponse>(
 serviceModuleId: number,
    vacationQuotaId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId>>, TError = ErrorResponse>(
 serviceModuleId: number,
    vacationQuotaId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaRevisionsVacationQuotaIdQueryOptions(serviceModuleId,vacationQuotaId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






